import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';

type LinkProps = RouterLinkProps & MuiLinkProps;

// Componente de enlace personalizado
export const Link = ({ to, children, ...other }: LinkProps) => (
  <MuiLink component={RouterLink} to={to} {...other}>
    {children}
  </MuiLink>
);
